import angular from 'angular';
import moment from 'moment';
import { MeurhSolicitacoesFaltasService } from '../solicitacoesfaltas.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { IFalta } from '../models/falta.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

type IMeurhSolicitacoesfaltasIndexFilter = {
    empresa?: string;
    estabelecimento?: string;
    situacao?: string;
    trabalhador_tipo?: string;
    lotacao?: {
        lotacao: string;
    } | null;
};

export class MeurhSolicitacoesfaltasIndexController implements angular.IController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        'NewToaster',
        'MeurhSolicitacoesFaltasService',
        'ListagemService'
    ];

    public busy: boolean = false;
    public dataInicial: string | null = null;
    public dataFinal: string | null = null;
    public dataAtual: moment.Moment = moment();
    public tipo: string;
    public tipoInicial: string;
    public filters: IMeurhSolicitacoesfaltasIndexFilter = {};
    public stateService: angular.ui.IStateService;
    public entities: Array<IFalta>;
    public empresas: Array<Empresa>;
    public estabelecimentos: Array<Estabelecimento>;
    public listagemPermissao: Array<string> = ['visualizar_falta'];
    public permissaoGrupoEmpresarial = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            temPermissao: (arg: string) => boolean,
            session: any,
            nsjGlobals: any,
            tipo: any,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public $location: angular.ILocationService,
        public NewToaster: { pop: Function },
        public entityService: MeurhSolicitacoesFaltasService,
        public ListagemService: ListagemService
    ) {
        if (!$rootScope.temPermissao('visualizar_falta')) {
            $state.go('dp', $stateParams);
        }

        entityService.filter = $stateParams['q'] ? $stateParams['q'] : '';
        entityService.filters = {};
        entityService.constructors = {};

        this.tipo = $stateParams.trabalhador.tipo;
        this.tipoInicial = $stateParams.trabalhador.tipo;
        this.stateService = $state;

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.filters = {
            ...this.filters,
            trabalhador_tipo: this.tipo === '-1' ? '' : this.tipo,
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
        };

        this.montaListagemVisibilidade();

        this.entities = this.filterReload();

        $rootScope.$on('meurh_solicitacoesfaltas_list_finished', () => {
            entityService.entities.forEach((item: IFalta): void => {
                if (item.hasOwnProperty('datas') && typeof(item.datas) === 'string') {
                  item.datas = item.datas.replace(/[{}]/g, '').split(',');
                }
            });
        });

        $scope.$on('meurh_solicitacoesfaltas_deleted', () => {
            entityService.reload();
        });

        $scope.$on('$destroy', (): void => {
            if (entityService.loading_deferred) {
                entityService.loading_deferred.resolve();
            }
        });

        $scope.$on('meurh_solicitacoesfaltas_submitted', (event: angular.IAngularEvent, args: any): void => {
            if (!args.autosave && args.entity.situacao !== -1) {
                entityService.reload();
            }
        });
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        delete this.filters.lotacao;
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    constructorEmpresaEstabelecimento() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    escondeRascunhos(obj: IFalta): boolean {
        if (obj.situacao === -1) {
            return false;
        } else {
            return true;
        }
    }

    search(): Array<IFalta> {
        if (this.entityService.filter !== '') {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.entityService.filter }));
        } else {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters));
        }

        const filter = {
            search: this.entityService.filter,
            filters: angular.copy(this.entityService.filters)
        };
        return this.entityService.search(filter);
    }

    loadMore(): void {
        this.entityService.loadMore();
    }

    finished(): boolean {
        return this.entityService.loadParams.finished;
    }

    isBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    filterReload() {
        const constructors: any = { ...this.filters };

        if (!this.valorExiste(constructors.situacao)) {
            delete constructors.situacao;
        }

        if (!this.valorExiste(constructors.trabalhador_tipo)) {
            delete constructors.trabalhador_tipo;
        }

        if (!this.valorExiste(constructors.lotacao)) {
            delete constructors.lotacao;
        } else {
            constructors.lotacao = constructors.lotacao.lotacao;
        }

        if (
            this.dataInicial !== null && this.dataFinal !== null &&
            this.dataInicial !== '' && this.dataFinal !== '' &&
            this.dataInicial > this.dataFinal
        ) {
            this.NewToaster.pop({
                type: 'error',
                title: 'A data inicial não pode ser posterior a data final'
            });
            return [];
        }

        const created_at: { condition: string, value: string }[] = [];

        if (
            this.dataInicial === undefined ||
            (this.dataInicial !== null && this.dataInicial.length === 0)
        ) {
            this.dataInicial = null;
            constructors.datainicial = null;
        }

        if (this.dataInicial !== null) {
            created_at.push({
                condition: 'gte',
                value: this.dataInicial + ' 00:00:00'
            });

            delete constructors.datainicial;
        }

        if (
            this.dataFinal === undefined ||
            (this.dataFinal !== null && this.dataFinal.length === 0)
        ) {
            this.dataFinal = null;
            constructors.datafinal = null;
        }

        if (this.dataFinal !== null) {
            created_at.push({
                condition: 'lte',
                value: this.dataFinal + ' 23:59:59'
            });

            delete constructors.datafinal;
        }

        constructors.created_at = created_at;
        this.entityService.constructors = constructors;
        return this.entityService.reload();
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
